import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes, Ref } from 'react';
import { cx } from '../cx';

export function Field({
  label,
  hint,
  error,
  children,
  htmlFor,
}: {
  label: string;
  hint?: string;
  error?: string;
  htmlFor?: string;
  children: ReactNode;
}) {
  return (
    <div className="rr-field">
      <label className="rr-field__label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {error ? <span className="rr-field__error">{error}</span> : hint ? <span className="rr-field__hint">{hint}</span> : null}
    </div>
  );
}

export function Input({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={cx('rr-input', className)} {...rest} />;
}

export function Textarea({ className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement> & { ref?: Ref<HTMLTextAreaElement> }) {
  return <textarea className={cx('rr-textarea', className)} {...rest} />;
}

export { Select, NativeSelect } from './Select';

/** Liga/desliga com rótulo ao lado. Para opção que vale na hora, sem botão de salvar. */
export function Toggle({ checked, onChange, label, hint, disabled }: { checked: boolean; onChange: (v: boolean) => void; label: ReactNode; hint?: ReactNode; disabled?: boolean }) {
  return (
    <button type="button" role="switch" aria-checked={checked} disabled={disabled} className={cx('rr-toggle', checked && 'rr-toggle--on')} onClick={() => onChange(!checked)}>
      <span className="rr-toggle__track" aria-hidden><span className="rr-toggle__thumb" /></span>
      <span className="rr-toggle__text"><span>{label}</span>{hint && <small>{hint}</small>}</span>
    </button>
  );
}
